import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "label", "checked", "defaultChecked", "disabled", "onChange", "inputRef", "tabIndex", "name", "id", "autoFocus", "children", "invalid", "value", "role"];
import * as React from 'react';
import cx from 'classnames';
import { HiddenInput } from '../HiddenInput';
import * as styles from './styles.module.css';
export var ControlInputContainer = /*#__PURE__*/React.forwardRef(function ControlInputContainer(props, ref) {
  var type = props.type,
    label = props.label,
    checked = props.checked,
    defaultChecked = props.defaultChecked,
    disabled = props.disabled,
    onChange = props.onChange,
    inputRef = props.inputRef,
    tabIndex = props.tabIndex,
    name = props.name,
    id = props.id,
    autoFocus = props.autoFocus,
    children = props.children,
    invalid = props.invalid,
    value = props.value,
    role = props.role,
    rest = _objectWithoutProperties(props, _excluded);
  var handleChange = function handleChange(e) {
    if (onChange) {
      onChange(e, e.currentTarget.checked);
    }
  };
  return /*#__PURE__*/React.createElement("label", _extends({}, rest, {
    className: cx(rest.className, styles['container']),
    ref: ref
  }), /*#__PURE__*/React.createElement(HiddenInput, _extends({}, value && {
    value: value
  }, {
    type: type,
    ref: inputRef,
    checked: checked,
    defaultChecked: defaultChecked,
    disabled: disabled,
    onChange: handleChange,
    tabIndex: tabIndex,
    name: name,
    id: id,
    autoFocus: autoFocus,
    role: role
  })), children);
});